import React, { useState, useEffect } from 'react';
import { useQuery, useMutation } from 'react-query';
import { adminUsersService, sortAssignableUsersByLastName, } from 'src/Utils/adminUsersService';
import { ticketsService } from 'src/Utils/ticketsService';
import { SUCCESS_MESSAGES, ERROR_MESSAGES } from 'src/Utils/toastMessages';
import { showSuccessToast, showErrorToast } from 'src/Utils/toastHelper';
import { Card, CardTitle, ContentContainer, OwnerRow, OwnerLabel, OwnerValue, DropdownContainer, DropdownLabel, RequiredText, } from './styles';
import { COMPLETED } from 'src/Utils/constants';
import SearchableSelect from 'src/Components/Common/SearchableSelect/SearchableSelect';
var TicketManagementInfo = function (_a) {
    var ticket = _a.ticket;
    var isTicketCompleted = ticket.status === COMPLETED;
    var _b = useQuery('assignableUsers', adminUsersService.getAssignableUsers, {
        onError: function (err) {
            console.error('Error fetching assignable users:', err);
        },
    }), _c = _b.data, assignableUsers = _c === void 0 ? [] : _c, isLoading = _b.isLoading, error = _b.error;
    var _d = useState(ticket.assignee_id || null), selectedAssigneeId = _d[0], setSelectedAssigneeId = _d[1];
    useEffect(function () {
        setSelectedAssigneeId(ticket.assignee_id || null);
    }, [ticket.assignee_id]);
    var _e = useMutation(function (assigneeId) {
        return ticketsService.updateTicket({
            id: ticket.id,
            assignee_id: assigneeId,
        });
    }, {
        onSuccess: function () {
            showSuccessToast(SUCCESS_MESSAGES.tickets.assigned);
        },
        onError: function (error) {
            console.error('Error updating ticket:', error);
            showErrorToast(error, ERROR_MESSAGES.tickets.assign);
            setSelectedAssigneeId(ticket.assignee_id || null);
        },
    }), mutateUpdateTicket = _e[0], isUpdating = _e[1].isLoading;
    var getFullName = function (firstName, lastName) {
        if (!firstName || !lastName)
            return null;
        return firstName + " " + lastName;
    };
    var getOwnerName = function () {
        var _a, _b;
        if (ticket.created_by_type === 'AdminUser') {
            return (getFullName(ticket.created_by.first_name, ticket.created_by.last_name) ||
                'Información no disponible');
        }
        var apartmentContactName = getFullName((_a = ticket.apartment_contact) === null || _a === void 0 ? void 0 : _a.first_name, (_b = ticket.apartment_contact) === null || _b === void 0 ? void 0 : _b.last_name);
        if (apartmentContactName)
            return apartmentContactName + " (cliente)";
        var externalClientName = getFullName(ticket.external_client_first_name, ticket.external_client_last_name);
        if (externalClientName)
            return externalClientName + " (cliente)";
        return 'Información no disponible';
    };
    var handleAssigneeChange = function (value) {
        if (isUpdating || isTicketCompleted || value === null)
            return;
        var assigneeId = value;
        setSelectedAssigneeId(assigneeId);
        mutateUpdateTicket(assigneeId);
    };
    return (React.createElement(Card, null,
        React.createElement(CardTitle, null, "Gesti\u00F3n del ticket"),
        React.createElement(ContentContainer, null,
            React.createElement(OwnerRow, null,
                React.createElement(OwnerLabel, null, "Propietario:"),
                React.createElement(OwnerValue, null, getOwnerName())),
            React.createElement(DropdownContainer, null,
                React.createElement(DropdownLabel, null,
                    "Asignar ticket a ",
                    React.createElement(RequiredText, null, "(Requerido)")),
                error ? (React.createElement("div", null, "Error al cargar administradores")) : (React.createElement(SearchableSelect, { value: selectedAssigneeId, onChange: handleAssigneeChange, options: sortAssignableUsersByLastName(assignableUsers).map(function (user) { return ({
                        value: user.id,
                        label: user.first_name + " " + user.last_name,
                    }); }), placeholder: "Selecciona un administrador", disabled: isUpdating || isTicketCompleted }))))));
};
export default TicketManagementInfo;
